export enum LOADER_TYPE {
  GLOBAL,
  LOCAL,
}

// prettier-ignore
export const GlobalLoaderRequests = ['/get-user-info', '/dropdowns'];
export const NoLoaderRequests = ['/notifications-mattermost'];
